<template>
  <div class="footer">
    <div class="footer-content flex-top">
      <div>
        <div><img class="footer-logo" :src="logo.logorev" width="310" :alt="logo.alt" /></div>
        <div class="subhd">
          {{ subhead }}
        </div>
        <div style="margin-top:35px">
          <div class="fg-greytext">
            {{ yourlocal }}
          </div>
          <div style="font-size:20px">
            {{ $nippets.footer.cityCountry }}
          </div>
        </div>
        <div style="margin-top:35px;font-size:20px;font-weight:500">
          <div><a :href="'mailto:' + email" v-on:click="sendAgentEmailClick">{{ email }}</a></div>
          <div style="margin-top:10px" v-on:click="sendCallClick"><a :href="'tel:' + $nippets.tel.code">{{ $nippets.tel.display }}</a></div>
        </div>
        <div style="margin-top:25px;line-height:27px" 
          class="pre-break">{{ $nippets.footer.address }}</div>
        <div style="font-size:14px;margin-top:20px">
          {{ $nippets.footer.byAppointment }}
        </div>
      </div>
      <div class="device-margin" v-if="$store.state.lang !== 'CN'">
        <div >{{ $nippets.followUs }}</div>
        <follow-us inverse :animation="animation" />
      </div>
    </div>
    <div class="footer-foot flex-top" :class="{extended: $store.state.showingTabs}">
      <div class="flex-left flex-top">
        <div>&copy; {{ $nippets.footer.copyright }}</div>
        <div>T: <a :href="'tel:' + $nippets.tel.code">{{ $nippets.tel.display }}</a></div>
        <div><a :href="'mailto:' + email">{{ $nippets.footer.emailUs }}</a></div>
        <div><ix-router-link to="/disclaimer">{{ $nippets.footer.disclaimer }}</ix-router-link></div>
        <div><ix-router-link to="/terms">{{ $nippets.footer.terms }}</ix-router-link></div>
        <div><ix-router-link to="/privacy-policy">{{ $nippets.footer.privacy }}</ix-router-link></div>
        <div><a href="http://www.saahub.com/" target="_blank" rel="nofollow noopener">{{ $nippets.footer.saaMember }}</a></div> 
      </div>
      <div class="flex-right">
        <a href="http://manifest.co/digital/illustration/" rel="noopener nofollow" target="_blank">{{ $nippets.footer.websiteDesign }}</a>
      </div>
    </div>
  
  </div>
</template>

<script>
import FollowUs from '@/components/panels/FollowUs.vue'
import logos from './logos.js'

export default {  
  components: {
    FollowUs
  },
  props: {
    animation: Boolean
  },
  computed: {
    logo () {
      if(this.animation) {
        return logos.anim
      }
      return logos.illus
    },
    subhead () {
      return this.animation ? this.$nippets.animation.subhead : this.$nippets.illustration.subhead
    },
    email () {
      return this.animation ? this.$nippets.animation.email : this.$nippets.illustration.email
    },
    yourlocal () {
      return this.animation ? this.$nippets.footer.yourLocalAnim : this.$nippets.footer.yourLocal
    }
  },
  methods: {
    sendCallClick() {
      this.$k.sendGaEvent('AgentTracking', 'CallClick', this.$store.state.lang)
    },
    sendAgentEmailClick () {
      this.$k.sendAgentEmailEvent(this.email)
    },
  }
}
</script>



<style scoped>
.footer{
  background-color:#fff;
  position:relative;
  color:#fff;
  font-size:17px;
  font-weight:400;
  box-sizing:border-box;
}
.footer-content{
  background-color:rgba(16,24,32,0.95);
  padding:55px 45px;
  box-sizing:border-box;
}
.footer-foot{
  background-color:#101820;
  padding:37px 45px 65px 45px;
  font-size:16px;
  box-sizing:border-box;
  transition: padding-bottom linear 0.2s;
}

.footer-foot.extended{
  padding-bottom:510px;
}

.footer-foot .router-link-active{
  color:#ce0e2d;
}

.footer a{
  color:#fff;
  text-decoration:none;
}

.footer a:hover{
  color:#ce0e2d;
}

.flex-top{
  display:flex;
  align-items:flex-start;
  justify-content:space-between;
}

.flex-top div{
  padding-right:16px;
}

.flex-left{
  width: 70%;
  justify-content:space-between;
}

@media screen and (max-width:1100px)
{
  .footer-content{
    padding-left:25px;
    padding-right:25px;
  }

  .flex-left{
    width:100%;
  }

  .flex-top{
    display:block;
  }

  .flex-top div{
    margin-bottom:10px;
  }

  .device-margin{
    margin-top:30px;
  }

  .footer-content{
    padding-left:25px;
    padding-right:25px;
  }
  
}

@media screen and (max-width:640px)
{
  .footer-content{
    padding-top:15px;
    padding-left:10px;
    padding-right:10px;
  }

  .footer-logo{
    width:80vw;
  }

  .subhd{
    font-size:14px;
  }

  .flex-top{
    display:block;
  }

  .footer-foot{
    padding:10px;
  }

}


</style>

